import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './Navbar.css';

type NavLink = {
  label: string;
  href: string;
};

const NAV_LINKS: NavLink[] = [
  { label: 'Home', href: '/' },
  { label: 'Solutions', href: '/solutions' },
  { label: 'Science', href: '/science' },
  { label: 'Industry Projects', href: '/industry-projects' },
  { label: 'Resources', href: '/resources' },
  { label: 'Team', href: '/team' },
];

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  const closeMenu = () => setIsOpen(false);

  return (
    <div className="navbar-container">
      <nav className="navbar">
        <Link to="/" className="navbar-brand" onClick={closeMenu}>
          <img
            src="/images/P__1_-removebg-preview (1).png"
            alt="PreciQube logo"
            className="navbar-logo brand-logo"
          />
          <span className="navbar-title">PreciQube</span>
        </Link>

        <div className="navbar-links">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`navbar-link ${pathname === link.href ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="navbar-actions">
          <a
            href="https://simulation.preciqube.com"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar-cta navbar-cta--outline"
          >
            Optical Simulator
          </a>
          <Link to="/contact" className="navbar-cta navbar-cta--solid">
            Join Us
          </Link>
        </div>

        <button
          className="navbar-toggle"
          onClick={() => setIsOpen((v) => !v)}
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isOpen}
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {isOpen && (
        <div className="navbar-mobile">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`navbar-mobile-link ${pathname === link.href ? 'active' : ''}`}
              onClick={closeMenu}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/contact" className="navbar-mobile-link" onClick={closeMenu}>
            Contact Us
          </Link>
          <a
            href="https://simulation.preciqube.com"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar-cta navbar-cta--outline navbar-mobile-cta"
            onClick={closeMenu}
          >
            Optical Simulator
          </a>
          <Link
            to="/contact"
            className="navbar-cta navbar-cta--solid navbar-mobile-cta"
            onClick={closeMenu}
          >
            Join Us
          </Link>
        </div>
      )}
    </div>
  );
};

export default Navbar;
